var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStat2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_140_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.3448 67.9425H10.1379L20.5912 90.3344C23.042 95.5843 29.399 97.6987 34.5061 94.9627C39.2458 92.4234 41.1634 86.6149 38.8672 81.7528L32.3448 67.9425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 59.8085H49.3941C56.524 59.8085 62.4681 65.2645 63.0776 72.3683L63.3884 75.9908C63.5783 78.2042 65.4304 79.9042 67.6519 79.9042C70.0152 79.9042 71.931 77.9883 71.931 75.625V4.27508C71.931 1.91402 70.017 0 67.6559 0C65.4333 0 63.5814 1.70318 63.3958 3.91808L63.0776 7.7153C62.4684 14.9844 56.3907 20.5741 49.0961 20.5741H15C6.71573 20.5741 0 27.2899 0 35.5741V44.8085C0 53.0928 6.71573 59.8085 15 59.8085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9031 57.0607L85.9052 53.0973C84.2548 52.2795 82.2546 52.7913 81.1998 54.3012C79.8846 56.1841 80.5712 58.7971 82.6421 59.7903L90.6906 63.65C92.3774 64.4589 94.4027 63.8678 95.3895 62.2785C96.5303 60.4413 95.8408 58.021 93.9031 57.0607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4805 36.8422H83.7264C81.7446 36.8422 80.1379 38.4489 80.1379 40.4307C80.1379 42.4126 81.7446 44.0192 83.7264 44.0192H92.4805C94.4623 44.0192 96.069 42.4126 96.069 40.4307C96.069 38.4489 94.4623 36.8422 92.4805 36.8422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8851 16.8449L82.427 20.9231C80.4324 22.0137 79.8271 24.595 81.1289 26.4587C82.221 28.0221 84.2993 28.5397 85.9971 27.6712L93.5647 23.8001C95.8275 22.6426 96.4155 19.6754 94.7652 17.7424C93.5559 16.3259 91.5191 15.9514 89.8851 16.8449Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_140_248",
    x: 0,
    y: 0,
    width: 96.069,
    height: 100.162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_140_248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStat2);
export default __webpack_public_path__ + "static/media/stat2.75497cc9a84023a2297092dec809bddf.svg";
export { ForwardRef as ReactComponent };